import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The taxonomy and flows screens' words, through GeoNexora's i18next.
 *
 * <p>The screens were ported from Veramenta's back office, whose keys are flat and dotted
 * (`tx.flow.addState`, `tx.op.==`). i18next reads a dot as nesting, and some of those keys are
 * also the start of others (`taxonomy.packageKind` and `taxonomy.packageKind.package`), so they
 * are kept in `global.json` under `taxonomyAdmin` with each dot written as an underscore.
 */
export type Locale = string;
export type MessageKey = string;
export type Translate = (key: MessageKey, vars?: Record<string, string | number>) => string;

const NAMESPACE = 'taxonomyAdmin';

export function messageKey(key: string): string {
  return `${NAMESPACE}.${key.replace(/\./g, '_')}`;
}

export function useT(): { t: Translate; locale: Locale } {
  const { t: translate, i18n } = useTranslation();
  const locale = (i18n.language || 'en').substring(0, 2);
  const t = useCallback<Translate>((key, vars) => translate(messageKey(key), { ...(vars ?? {}), defaultValue: key }) as string, [translate]);
  return { t, locale };
}
